import type {MemexItemModel} from '../../../../models/memex-item-model'
import {getBehaviorForColumn} from './columns'
import {extractCellData} from './extract-cell-data'
import type {ClipboardColumnModel, ClipboardContent} from './types'

export const getClipboardContentFromItemAndColumn = (
  columnModel: ClipboardColumnModel | undefined,
  item: MemexItemModel,
): ClipboardContent | undefined => {
  if (!columnModel) return
  const cellData = extractCellData(columnModel, item)
  if (!cellData) return

  const behavior = getBehaviorForColumn(columnModel)
  const clipboardContent = behavior.readContent(cellData.item, cellData.columnModel)
  if (!clipboardContent) return

  return {
    ...clipboardContent,
    columnId: cellData.columnModel.id,
    itemId: cellData.item.id,
  }
}
